import { method } from '@/api/api';
import {
  login
} from '@/api/auth';

import { clearForLogout, setToken, setTokenTime } from '@/utils/auth';
import { setItem } from '@/utils/storage';


export const actions = {

  async currentUser() {
    try {
      const res = await method("auth.profile")
      if (res.success && res.data) {
        this.user = res.data;
        // this.defaultRegion = this.user?.rights["stat2.it-park.uz"]?.region_ids[0];
        this.defaultRegion = this.user?.rights?.["stat2.it-park.uz"]?.region_ids?.length ? this.user?.rights?.['stat2.it-park.uz']?.region_ids?.length == 15 ? null : this.user?.rights["stat2.it-park.uz"]?.region_ids[0] : null
        this.role = res.data.role;
        this.setUser(res.data);
        return res.data;
      }
      return res;
    } catch (error) {
      console.error("Foydalanuvchi ma'lumotlarini olishda xatolik:", error);
    }
  },

  async logout() {
    try {
      const res = await method("auth.logout")
      if (res.success) {
        clearForLogout();
        this.isAuth = false;
        this.user = null;
        this.role = "";
        this.$reset()
      }
      return res;
    } catch (error) {
      console.error("Chiqishda xatolik:", error);
    }
  },

  async loginUser(data) {
    try {
      const res = await login(data);
      if (res.success && res.data) {
        setToken(res.data.access_token);
        setTokenTime(res.data.expires_in);
        this.isAuth = true;
      }
      return res;
    } catch (error) {
      console.error("Login xatosi:", error);
    }
  },
  async setTokenActions(params) {

    return new Promise((resolve) => {
      setToken(params['token']);
      setTokenTime(params['expires_in']);
      resolve(true);
    });
  },
  setUser(data) {
    this.user = data;
    if (this.user) {
      this.role_name = this.user.role;
      setItem("user", this.user);
    }
  },
  setIsAuth(value) {
    this.is_auth = value;
  },

};
